'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Styles = styleEncapsulation.labelStyles("TableFoot", {
  root: react.css`
    ${styleMixins_reset.boxSizing};
    display: table-footer-group;
  `
});
const TableFoot = (props) => {
  return react.jsx("tfoot", { css: Styles.root, "data-zds": true }, props.children);
};

exports.TableFoot = TableFoot;
//# sourceMappingURL=TableFoot.cjs.js.map
